import * as SETAPI from 'cd-eft/services/eftSetApi';
import axios from 'axios';


export async function ImageDownload(fileName) {

    if (fileName === '' || !fileName) return '';

    const accessToken = localStorage.getItem('accessToken') as string;
    const response = await SETAPI.SurfaceController.downloadFileUsingGET1(fileName, accessToken);

    if (response && response.config && response.config.url) {
        const imgURL = response.config.url

        const response2 = await axios.get(imgURL!, {
            headers: { Authorization: `Bearer ${accessToken}` },
            responseType: 'arraybuffer'
        });

        return `data:${response2.headers["content-type"]
            };base64,${new Buffer(response2.data, "binary").toString("base64")}`;
    } else {
        return "";
    }
}

/**
 * 
 * @param data Should be of type Int8Array - array of integers from [-128, 127]
 */
export function ByteArrayToImageUrl(data: Int8Array) {
    const arr = new Int8Array(data);
    const blob = new Blob([arr], { type: 'image/png' });
    return(URL.createObjectURL(blob))
}